import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { categoriesURL, teamsURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Teams from "../Templates/Home/Teams/Teams";

function TeamsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState(false);
  const [filters, setFilters] = useState({
    accountPaid: "",
    competitionType: "",
    categoryId: "",
    ageGroupId: "",
    hasDiscount: "",
    discountPercentage: "",
  });

  const getFilterQueryString = (filters) => {
    const queryParams = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => {
        // if (key === "competitionType") {
        //   if (value === "online") {
        //     return "onlineParticipant=1&offlineParticipant=0";
        //   } else if (value === "offline") {
        //     return "onlineParticipant=0&offlineParticipant=1";
        //   } else if (value === "both") {
        //     return "onlineParticipant=1&offlineParticipant=1";
        //   }
        //   return "";
        // }
        return `${key}=${value}`;
      })
      .filter((param) => param !== "")
      .join("&");
    return queryParams;
  };

  const [teams, setTeams] = useState([]);
  const [teamsNumber, setTeamsNumber] = useState(0);
  const { data: categories } = useFetch(`${categoriesURL}/withAgeGroups`);
  const { data, loading, error } = useFetch(
    teamsURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${sortBy ? `&sortBy=${sortBy}` : ""}${
      sortOrder ? `&sortDesc=${sortOrder}` : ""
    }${
      getFilterQueryString(filters) ? `&${getFilterQueryString(filters)}` : ""
    }`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setTeams(data.data?.data?.rows);
      setPageCount(data.data?.data?.numberOfPages);
      setTeamsNumber(data.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "teams", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const handleSortOrderChange = (event) => {
    setSortOrder(event.target.value);
  };

  const handleFilterChange = (event) => {
    if (event.target.name === "categoryId") {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
        ageGroupId: "",
      });
    } else {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
      });
    }
  };

  return (
    <Teams
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      teams={teams}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setTeams={setTeams}
      setPage={setPage}
      sortBy={sortBy}
      sortOrder={sortOrder}
      filters={filters}
      handleSortChange={handleSortChange}
      handleSortOrderChange={handleSortOrderChange}
      handleFilterChange={handleFilterChange}
      teamsNumber={teamsNumber}
      categories={categories?.data}
      getFilterQueryString={getFilterQueryString}
    />
  );
}

export default TeamsPage;
